<app-form-field-wrapper
  [name]="'bookmark'"
  label="Was soll verlinkt werden?"
  [colSize]="12">
  <p-dropdown
    [group]="true"
    [filter]="true"
    [(ngModel)]="selection"
    (ngModelChange)="onChange($event)"
    [filterFields]="['label']"
    [options]="options">
    <ng-template pTemplate="selectedItem" let-selectedOption>
      <div class="flex gap-2 align-items-center">
        <i [class]="selectedIcon"></i>
        <span>{{ selectedLabel }}</span>
      </div>
    </ng-template>

    <ng-template let-group pTemplate="group">
      <div class="flex gap-2 align-items-center">
        <i [class]="group.icon"></i>
        <span>{{ group.label }}</span>
      </div>
    </ng-template>

    <ng-template let-item pTemplate="item">
      <div class="flex gap-2 align-items-center">
        <span>{{ item.label }}</span>
      </div>
    </ng-template>
  </p-dropdown>
</app-form-field-wrapper>
